export function demandReducer(state = { 
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_DEMAND": 
        case "UPDATE_DEMAND": 
            return {
                [payload.id]: payload,
                ...state
            };
        case "RECEIVED_DEMAND":        
            return {
                ...state,
                [payload]: {
                    ...state[payload],
                    received: true
                }
            }
        case "GET_DEMANDS":        
            return payload;
        
        case "DELETE_DEMAND":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}